"use strict";
import { addMultipleListeners } from "./helpers";
import Collapse from 'bootstrap/js/dist/collapse';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';
document.addEventListener("DOMContentLoaded", function () {
    const collapseElementList = document.querySelectorAll('.collapse');
    const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl, { toggle: false }));
    // Toggle menu and overlay
    const toggleMenu = (state) => {
        document.body.classList.toggle('menu-open', state);
        const overlay = document.getElementById('fn_overlay');
        if (overlay) {
            overlay.classList.toggle('p_overlay--active', state);
        }
    };
    // Menu button click
    const menuBtn = document.getElementById('fn_menu-btn');
    if (menuBtn) {
        addMultipleListeners(menuBtn, ['click', 'touch'], () => {
            if (document.body.classList.contains('menu-open')) {
                toggleMenu(false);
            }
            else {
                toggleMenu(true);
            }
        });
    }
    // Menu close button click
    const menuCloseBtn = document.getElementById('fn_menu-close');
    if (menuCloseBtn) {
        addMultipleListeners(menuCloseBtn, ['click', 'touch'], () => toggleMenu(false));
    }
    // Escape key press
    document.body.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            toggleMenu(false);
        }
    });
    // Overlay click
    const overlay = document.getElementById('fn_overlay');
    if (overlay) {
        addMultipleListeners(overlay, ['click', 'touch'], () => {
            toggleMenu(false);
        });
    }
    // Init PhotoSwipe gallery
    const lightbox = new PhotoSwipeLightbox({
        gallery: '.fn_gallery',
        children: 'figure > a',
        showHideAnimationType: 'zoom',
        pswpModule: PhotoSwipe
    });
    lightbox.init();
});
